import BreadCrumbs from '../../components/SharedComponents/BreadCrumbs/BreadCrumbs';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(BreadCrumbs);
